import React, { Component } from 'react';
import PropTypes from 'prop-types';
import memoize from 'memoize-one';
import classNames from 'classnames';
import {
  List,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from 'react-virtualized';
import InfinityLoader from 'react-virtualized/dist/es/InfiniteLoader';
import DashboardFilter from '../../components/_molecules/DashboardFilter/DashboardFilter';
import { SUCCESS, TEXT_FIELD_STATUS, publicHash } from '../../utils/constants';
import { getFieldInitialState } from '../../utils/helpers';
import './AdminAppsList.scss';
import ArrowButton from '../../components/_atomic/ArrowButton/ArrowButton';

const appPlaceholder = require('./assets/no-app.png');

const clientFilterName = 'client-filter';
const cache = new CellMeasurerCache({
  fixedWidth: true,
  minHeight: 288,
});

class AdminAppsList extends Component {
  static propTypes = {
    getAllUsersShort: PropTypes.func.isRequired,
    hasMoreUsersShort: PropTypes.bool.isRequired,
    pageUsersShort: PropTypes.number.isRequired,
    usersShortStatus: PropTypes.string.isRequired,
    usersShort: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getUsersWithApps: PropTypes.func.isRequired,
    hasMoreUsersWithApps: PropTypes.bool.isRequired,
    pageUsersWithApps: PropTypes.number.isRequired,
    usersWithAppsStatus: PropTypes.string.isRequired,
    usersWithApps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    // onlyUsersWithApps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    resetUsersWithApps: PropTypes.func.isRequired,
    resetUsersWithAppsArray: PropTypes.func.isRequired,
    sidebarStatus: PropTypes.bool,
    match: PropTypes.shape({
      params: PropTypes.shape({
        userId: PropTypes.string,
      }),
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    changeAdminBarId: PropTypes.func.isRequired,
  };
  static defaultProps = {
    sidebarStatus: true,
  }
  state = {
    filters: {
      [clientFilterName]: getFieldInitialState(),
    },
  };

  componentWillMount() {
    this.props.getAllUsersShort({ page: 0 });
    const { match: { params: { userId } }, changeAdminBarId } = this.props;
    const filters = { ...this.state.filters };
    if (userId) {
      changeAdminBarId('apps');
      filters[clientFilterName].value = userId;
      this.setState(() => ({
        filters,
      }));
    }
    window.addEventListener('resize', this.updateDimensions);
  }
  componentDidUpdate(prevProps) {
    const {
      usersShortStatus,
      hasMoreUsersShort,
      pageUsersShort,
      getAllUsersShort,
      usersWithApps,
      match: { params: { userId } },
    } = this.props;
    if (
      usersShortStatus !== prevProps.usersShortStatus &&
      usersShortStatus === SUCCESS &&
      hasMoreUsersShort
    ) {
      getAllUsersShort({ page: pageUsersShort + 1 });
    }
    if (userId !== prevProps.match.params.userId && !userId) {
      const filters = { ...this.state.filters };
      filters[clientFilterName].value = '';
      this.setState(() => ({
        filters,
      }), () => {
        this.loadMoreRows(true);
      });
    }

    const { usersWithAppsStatus, pageUsersWithApps } = this.props;
    if (
      usersWithAppsStatus !== prevProps.usersWithAppsStatus &&
      usersWithAppsStatus === SUCCESS
    ) {
      this.loadedResolved();
      // Need to look this in future
      if (pageUsersWithApps < 4
        || usersWithApps.length === 1 || prevProps.usersWithApps.length === 1) {
        cache.clearAll();
      }
    }
  }
  componentWillUnmount() {
    this.props.resetUsersWithApps();
  }
  updateDimensions = () => {
    this.loadMoreRows(true);
  };
    clientFilterChangeHandler = ({ name, value }) => {
      const filters = {
        ...this.state.filters,
      };
      if (value) {
        filters[name].status = TEXT_FIELD_STATUS.VALID;
      } else {
        filters[name].status = TEXT_FIELD_STATUS.INITIAL;
      }
      filters[name].value = value.value;
      this.setState(
        () => ({ filters }),
        () => {
          this.loadMoreRows(true);
          cache.clearAll();
        },
      );
    };
  transformUsersForFilter = memoize((users, all) => {
    let transformedUsers = [];
    if (users) {
      transformedUsers = all.map(user => ({
        label: user.profile.fullName,
        value: user.id,
      }));
    }

    const firstElement = [
      {
        label: 'All',
        value: '',
      },
    ];
    return [...firstElement, ...transformedUsers];
  });

  loadMoreRows = (forceUpdate) => {
    const {
      hasMoreUsersWithApps,
      pageUsersWithApps,
      getUsersWithApps,
      resetUsersWithAppsArray,
    } = this.props;
    const { filters } = this.state;
    const userId = filters[clientFilterName].value;

    if (userId) {
      resetUsersWithAppsArray();
      getUsersWithApps({ userId, page: 0 });
      return new Promise((resolve) => {
        this.loadedResolved = resolve;
      });
    } else
    if (hasMoreUsersWithApps) {
      getUsersWithApps({ page: pageUsersWithApps + 1, userId });
      return new Promise((resolve) => {
        this.loadedResolved = resolve;
      });
    }
    if (forceUpdate && !userId) {
      getUsersWithApps({ page: 0, userId });
      return new Promise((resolve) => {
        this.loadedResolved = resolve;
      });
    }
    return () => {};
  };

  isRowLoaded = ({ index }) => {
    const { usersWithApps, hasMoreUsersWithApps } = this.props;
    return !hasMoreUsersWithApps || index < usersWithApps.length;
  };
  appListRenderer = (appList, userId) => (
    <div className="app-list-wrapper">{appList.map(app => this.appRenderer(app, userId))}</div>
  );
  appRenderer = (app, userId) => (
    <div className="app-wrapper">
      {app.unread && <div className="notification-wrapper" /> }
      <div className="app-image-wrapper"><div tabIndex={0} onKeyDown={() => {}} role="button" onClick={() => { this.navigateToApp(app.id, userId); }} className="app-image" style={{ backgroundImage: `url(${app.logo})` }} /></div>
      <div className="app-name"><span>{app.name}</span></div>
    </div>
  )
  navigateToApp = (appId, userId) => {
    this.props.history.push(`${publicHash}/app/${appId}/campaigns/${userId}/`);
  }
  navigateToBack = () => {
    window.history.back();
  }
  rowRenderer = ({
    index, key, style, parent,
  }) => {
    let content;
    const { usersWithApps } = this.props;
    const currentUser = usersWithApps[index];
    if (!this.isRowLoaded({ index })) {
      content = (
        <div key={key} className="ct-td">
          <span>Loading...</span>
        </div>
      );
    } else {
      content = (
        <div key={key} style={style} className="apps-list-row">
          <div className="company-name">
            <span>{currentUser.profile.company}</span>
          </div>
          <div className="user-name">
            <span>{currentUser.profile.fullName}</span>
          </div>
          <div className="user-apps-wrapper">
            {currentUser.apps.length ? (
             this.appListRenderer(currentUser.apps, currentUser.id)
            ) : (
              <div className="app-wrapper app-placeholder">
                <div className="app-image-wrapper"> <img src={appPlaceholder} alt="placeholder" /> </div>
                <div className="app-name">No apps</div>
              </div>

            )}
          </div>
        </div>
      );
    }
    return (
      <CellMeasurer
        cache={cache}
        columnIndex={0}
        key={key}
        parent={parent}
        rowIndex={index}
      >
        {content}
      </CellMeasurer>
    );
  };
  rowCountFunc = () => {
    const { hasMoreUsersWithApps, usersWithApps } = this.props;
    const status = [];
    if (hasMoreUsersWithApps) {
      status.push({ val: usersWithApps.length + 1 });
    } else {
      status.push({ val: usersWithApps.length });
    }
    return status[0].val;
  };
  render() {
    const {
      usersShort,
      usersWithApps,
      sidebarStatus,
    } = this.props;
    const { filters } = this.state;

    const adminAppsListClasses = classNames({
      screen: true,
      'admin-apps-list': true,
    });
    const rowCount = this.rowCountFunc();
    const clientFilter = filters[clientFilterName];
    const transformedUsers = this.transformUsersForFilter(usersShort, usersWithApps);
    return (
      <div className={adminAppsListClasses}>
        <div className="main-label-no-transform">
          <ArrowButton onClick={this.navigateToBack} padLeft={sidebarStatus ? 125 : 125} />
          <span>Apps</span>
        </div>
        <div className="filter-wrapper">
          <DashboardFilter
            value={clientFilter.value}
            status={clientFilter.status}
            placeholder="By Client"
            label="By Client"
            changeHandler={this.clientFilterChangeHandler}
            values={transformedUsers}
            name={clientFilterName}
          />
        </div>
        <div className="apps-wrapper">
          <InfinityLoader
            rowCount={rowCount}
            loadMoreRows={this.loadMoreRows}
            isRowLoaded={this.isRowLoaded}
          >
            {({ onRowsRendered, registerChild }) => (
              <AutoSizer>
                {({ width, height }) => (
                  <List
                    ref={registerChild}
                    onRowsRendered={onRowsRendered}
                    rowRenderer={this.rowRenderer}
                    width={width}
                    height={height}
                    rowCount={rowCount}
                    deferredMeasurementCache={cache}
                    rowHeight={cache.rowHeight}
                  />
                )}
              </AutoSizer>
            )}
          </InfinityLoader>
        </div>
      </div>
    );
  }
}

export default AdminAppsList;



// WEBPACK FOOTER //
// ./src/containers/AdminAppsList/AdminAppsList.js